import { useState } from 'react';
import { TableContainer } from '@mui/material';

/**
 * A TableContainer whose first column stays put while the table scrolls sideways; its edge shadow shows once the
 * table has been scrolled. Pairs with stickyHeader tables: the top-left cell sits above both.
 */
export default function StickyTableContainer({ children, sx, ...props }) {
  const [scrolled, setScrolled] = useState(false);
  const onScroll = (event) => {
    const next = event.currentTarget.scrollLeft > 0;
    if (next !== scrolled) setScrolled(next);
  };

  return (
    <TableContainer onScroll={onScroll} {...props} sx={[{
      '& tr > :first-of-type': {
        position: 'sticky',
        left: 0,
        zIndex: 1,
        transition: 'box-shadow 0.2s',
        boxShadow: scrolled ? '6px 0 8px -6px rgba(37, 45, 82, 0.25)' : 'none',
      },
      '& thead tr > :first-of-type': { zIndex: 3 },
    }, ...(Array.isArray(sx) ? sx : [sx])]}>
      {children}
    </TableContainer>
  );
}
